module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.563/js/sprocket_white.svg"